var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetroIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.19456 6.00415C6.19456 4.1224 7.58571 2.54595 9.42266 2.39255C11.678 2.20421 14.6865 1.99732 16.9946 2.00003C19.2418 2.00266 22.165 2.20556 24.3731 2.39106C26.2094 2.54533 27.6 4.1216 27.6 6.00276V24.3533C27.6 26.3821 25.9891 28.0267 24.002 28.0267H9.79253C7.80543 28.0267 6.19456 26.382 6.19456 24.3533V6.00415Z",
    fill: "#1B41BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1838 30.7086L8.91892 32H6L10.3784 28.0265H13.1027L12.227 28.9205H21.7622L20.8865 28.0265H23.6108L27.8919 32H25.1676L23.8054 30.7086H10.1838Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75149 10.3774C7.75149 9.70115 8.28844 9.15292 8.95081 9.15292H15.1143C15.7767 9.15292 16.3136 9.70115 16.3136 10.3774V16.0742C16.3136 16.7505 15.7767 17.2987 15.1143 17.2987H8.95081C8.28844 17.2987 7.75149 16.7505 7.75149 16.0742V10.3774Z",
    fill: "#F3F3F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4811 10.3774C17.4811 9.70115 18.018 9.15292 18.6804 9.15292H24.8439C25.5063 9.15292 26.0432 9.70115 26.0432 10.3774V16.0742C26.0432 16.7505 25.5063 17.2987 24.8439 17.2987H18.6804C18.018 17.2987 17.4811 16.7505 17.4811 16.0742V10.3774Z",
    fill: "#F3F3F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35546 5.63362C8.14371 6.01326 8.14057 6.73061 8.14057 6.73061L16.8436 6.84031V3.98813C16.8436 3.98813 15.3394 3.98813 12.4384 4.20753C10.6022 4.34639 9.85968 4.31723 9.10757 4.75602C8.7203 4.98196 8.57617 5.23788 8.35546 5.63362Z",
    fill: "#5C78D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4392 5.63362C25.651 6.01326 25.6541 6.73061 25.6541 6.73061C25.6541 6.73061 16.9946 6.83419 16.8436 6.84031V5.41422V3.98813C16.8436 3.98813 18.4553 3.98813 21.3563 4.20753C23.1924 4.34639 23.935 4.31723 24.6871 4.75602C25.0744 4.98196 25.2185 5.23788 25.4392 5.63362Z",
    fill: "#5C78D4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3176 23.9953C11.3176 24.8406 10.6464 25.5259 9.81845 25.5259C8.99049 25.5259 8.31929 24.8406 8.31929 23.9953C8.31929 23.1499 8.99049 22.4647 9.81845 22.4647C10.6464 22.4647 11.3176 23.1499 11.3176 23.9953Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9391 23.9953C24.9391 24.8406 24.2679 25.5259 23.4399 25.5259C22.612 25.5259 21.9408 24.8406 21.9408 23.9953C21.9408 23.1499 22.612 22.4647 23.4399 22.4647C24.2679 22.4647 24.9391 23.1499 24.9391 23.9953Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4865 20.2067H6V19.0273H12.9511L16.5975 23.8059L20.1712 19.0273H27.0811V20.2067H20.7568L16.5975 25.5138L12.4865 20.2067Z",
    fill: "#FFD15C",
    stroke: "#FFD15C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetroIcon);
export default __webpack_public_path__ + "static/media/MetroIcon.65f7069326097bc8db6cda8568356deb.svg";
export { ForwardRef as ReactComponent };